module.exports = __webpack_public_path__ + "static/media/player_start.be86d6de.png";